import { List } from 'immutable';
import { Slide, colors } from '@material-ui/core';
import { ClassAttributes, createElement, Component, SyntheticEvent, ComponentType } from 'react';
import { css } from '@emotion/core';
// import Snackbar from './Snackbar';
import FormattedSnackbar from '../FormattedSnackbar';
import { TransitionProps } from '@material-ui/core/transitions/transition';

interface Props {
  errors: Error[];
  onRequestClose: (e: SyntheticEvent<HTMLElement>, err: Error) => void;
  className?: string;
}

interface State {
  snackbarProps: List<SnackbarProps>;
}

interface SnackbarProps {
  id: number;
  error: Error;
  open: boolean;
  transition: ComponentType<TransitionProps>;
}

class NonFatalErrorSnackbars extends Component<ClassAttributes<HTMLElement> & Props, State> {
  private lastErrorId: number;

  state: State = {
    snackbarProps: List(),
  };

  constructor(props: ClassAttributes<HTMLElement> & Props) {
    super(props);

    this.lastErrorId = 0;
  }

  componentDidUpdate(nextProps: ClassAttributes<HTMLElement> & Props) {
    const added = List(
      nextProps.errors.reduce(
        (whole, error) => {
          // added errors
          if (this.props.errors.indexOf(error) === -1) {
            this.lastErrorId += 1;

            return [
              ...whole,
              {
                id: this.lastErrorId,
                error,
                open: true,
                transition: (props: any) => <Slide direction="right" {...props} />,
              },
            ];
          }

          return whole;
        },
        [] as SnackbarProps[],
      ),
    );

    const existed = this.state.snackbarProps.map(entry => {
      // deleted errors
      if (nextProps.errors.indexOf(entry.error) === -1) {
        return { ...entry, open: false };
      }

      return entry;
    });

    this.setState({
      snackbarProps: existed.merge(added),
    });

    this.enqueueDeleteHiddenErrors();
  }

  shouldComponentUpdate(_: any, nextState: State) {
    return !this.state.snackbarProps.equals(nextState.snackbarProps);
  }

  render() {
    return this.state.snackbarProps
      .map(({ id, error, transition }) => (
        <FormattedSnackbar
          action="root.snackbar.close"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          message={error.message}
          onClickAction={e => this.props.onRequestClose(e, error)}
          onRequestClear={e => this.props.onRequestClose(e, error)}
          className={this.props.className}
          key={id}
          transition={transition}
          ContentProps={{
            classes: {
              root: css({ backgroundColor: colors.red[500] }).toString(),
            },
          }}
          buttonColor="inherit"
          raw={false}
        />
      ))
      .toArray();
  }

  private enqueueDeleteHiddenErrors = () => {
    setTimeout(
      () =>
        this.setState({
          snackbarProps: this.state.snackbarProps.filter(({ open }) => open),
        }),
      500,
    );
  };
}

export default NonFatalErrorSnackbars;
